<template>
    <div id="ReportPatientInsurance">
      <div v-if="this.showModal">
        <MdTitle v-bind:Text="$t('PatientInsurancesRep.RepTitle')" />
        <div class="row">
          <div class="col-sm-12 col-md-12 mb-4">
            <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                <div class="input-group" dir="ltr">
                      <input 
                        type="text" 
                        class="form-control"
                        :dir="dirInput"
                        v-model="parameter.SearchCriteria"   
                          @keyup.enter="SearchInsurances"                            
                      >
                      <div class="input-group-append">
                          <div class="input-group-append">
                          <MdButton 
                            v-bind:Name="'btnsearchinput'"
                            v-bind:VariantProp="'btn btn-sm search-attached'"
                            v-bind:IconClass="'mdi mdi-magnify'"
                            v-on:click="SearchInsurances">
                          </MdButton>
                      </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <b-row>
            <b-col lg="3" md="3" sm="12">         
              <MdSelect
                v-bind:Label="$tc('Shared.Patient',2)"
                v-bind:Options="PatientsList"
                v-bind:Model="PatientCodeModel"
                v-bind:FieldDescription="'patientName'"
                v-bind:FieldCode="'patientcode'"
                v-bind:Multiple="true"             
                :Input="ChangeDropDownPatients"
                :CustomLabel="customLabelPatients"/>
            </b-col>
            <b-col lg="3" md="3" sm="12">         
              <MdSelect
                v-bind:Label="$tc('Insurance.Insurance')"
                v-bind:Options="Insurances"
                v-bind:Model="insCode"
                v-bind:FieldDescription="'company'"
                v-bind:FieldCode="'insurancecode'"
                v-bind:Multiple="true"             
                :Input="ChangeDropDownInsurances"/>
            </b-col>
            <b-col lg="3" md="3" sm="12">         
              <MdSelect
                v-bind:Label="$t('Insurance.InsType')"
                v-bind:Options="InsuranceTypesList"
                v-bind:FieldDescription="'description'"
                v-bind:FieldCode="'code'"
                v-bind:Model="insType"
                v-bind:Multiple="true"
                :Input="ChangeDropDownInsType"
                v-bind:Name="'ins_type_select'"/>
            </b-col>
            <b-col lg="3" md="3" sm="12">
              <div class="text-md-right mt-3">
                  <button 
                      v-on:click="SearchInsurances"
                      type="button"
                      class="btn btn-primary btn-login mx-2"												
                      id="btnsearchinput">
                      {{ $t('Shared.Search') }}
                  </button>
              </div>
            </b-col>   
          </b-row>
        <div class="row">
          <div class="col-md-12">
              <MdTitle  v-bind:Text="$t('Shared.SearchResult')" 
                        v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
              <div class="row">
                <div class="col-md-12">
                <MdTable 
                  v-bind:fields="fields"
                  v-bind:items="items"
                  v-bind:totalRows="totalRows"
                  v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                  v-bind:currentPage="currentPage"
                  v-bind:perPage="perPage"
                  v-bind:pageOptions="pageOptions"
                  v-bind:refTable="refTable"
                  :pageChanged="pageChanged"
                  :perPageFunction="PerPageFunction">
                </MdTable>
              </div>
            </div>
          </div>
        </div>

        <div class="space-actions"></div>
        <div class="page-actions">
          <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="reportList"
            v-bind:Name="'btn_ReportList'"/>
          <MdButton
            v-bind:Label="$t('Shared.Report')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickShowReport"
            v-bind:Name="'btn_Print'"/>
            
          <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
						<b-dropdown-item v-on:click="handlePdf('export')">{{$t('Shared.PDF')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handlePdf('email')">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('export')">{{$t('Shared.CSV')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('email')">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
					</b-dropdown>

        </div>
      </div>
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('PatientInsurancesRep.RepTitle')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="patientInsurances"
          :ReportName="'PatientInsurances'"
          :ReportTitle="$tc('Insurance.Insurance', 2)"
          :IsAnAPIReport="true"
        />
    </DxPopup>
    <CSVExportHelper
      ref="csvExportHelper"
      v-bind:conformSubject="$tc('Insurance.Insurance',2)"
      v-bind:sendEmailAPI="'/PatientInsurances/email'"
      v-bind:exportCsvAPI="'/PatientInsurances/exportCSV'"
    >    
    </CSVExportHelper>
  </div>
</template>

<script>
import Vue from 'vue'
import { DxPopup } from 'devextreme-vue/popup';
import ShowMessage from '@/components/messages/ShowMessage.js';
import InsuranceService from "@/services/insurance.service";
import PatientService from '@/services/patient.service';
import Utils from '@/common/utils'
import DBFunctions from '@/common/DBFunctions.js'
import { EventBus } from '@/event-bus.js';

export default Vue.extend({
    name: "PatientInsurancesRep",
    mixins: [ ShowMessage, Utils, DBFunctions ],
    components: { DxPopup },
    props: {
      PatientCode: String,
      PatientCodeList: String,
      closeWindow: Function,
      RecNo: Number,
      showModal: Boolean
    },
    data() {
        return {
          OptionsRightMenu:{
              visible:false,
              ItemsList:[],
              btnvisible:false,
              itemdisabled: false,
              PatientCode:'',
              Mode:this.edit_mode,
              favButtonAtion:false          
            },
            isParamVisible: true,
            isReportVisible: false,
            reportParams: [],
            PatientsList:[],
            params: {
              PatientCodeList: [],
              InsTypeList:[],
              InsuranceCodeList:[]
            },
            parameter:{
              SearchCriteria:'',
              PageNumber : null,
              PageSize:null,
              Status: true,
            },
            PatientCodeModel: null,
            InsuranceTypesList: [],
            insType: null,
            insCode: null,
            company: null,
            isInsCodeValid: true,
            Insurances: [],
            items: [],         
            fields: [
                { key: 'patientName', sortable: true, label: this.$t('Shared.PatientName'), class: 'text-rigth' },
                { key: 'patientcode', sortable: true, label: this.$tc('Shared.PatientCode'), class: 'text-rigth' },
                { key: 'patientDOB', sortable: true, label: this.$t('Shared.Dob'), class: 'text-rigth' },
                { key: "insuranceTypeDescription", sortable: true, label: this.$t('Insurance.InsType'), class: "text-rigth" },
                { key: "insuranceName", sortable: true, label: this.$t('InsurancesList.colInsuranceName'), class: "text-rigth" },
                { key: "insuranceCode", sortable: true, label: this.$t('Insurance.InsuranceCode') },
                { key: "effectiveDate", sortable: true, label: this.$t('InsurancesList.colEffectiveDate'), class: "text-rigth" },
                { key: "termDate", sortable: true, label: this.$t('Shared.TerminationDate'), class: "text-rigth" },
                { key: "coPay", sortable: true, label: this.$t('Insurance.CoPay'), class: "text-rigth" },
                { key: "policyNo", sortable: true, label: this.$t('Insurance.PolicyNo'), class: "text-rigth" },
            ],
            pageOptions: [5, 10, 15 ],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            selected: [],
            Header:{},
            refTable: 'selectableTable', 
            ShowMessageIsEmpty:true,
            SearchCriteria:"",
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
        }
    },
    methods: {

      onShowing(e) {
        let contentElement = e.component.content();
        let titleElement = e.component._$title[0]
        contentElement.style.padding = '0px';
        titleElement.style.padding = '0px 20px'
      },

      onHiddenReport() {
        this.isReportVisible = false
        if(!this.showModal)
          this.closeWindow();
      },

      onClickClose() {
        this.closeWindow()
        this.isParamVisible = false;
      },

      reportList() {
        this.checkExistFavorite('/app/reports/patients');
        this.$router.push({ name: "reportListPatient" }).catch(()=>{});
      },

      initializeParameters() {
        ['PatientCode','recNo','insType'].forEach(
          key => this.parameter[key] = null
        );

        this.parameter.PatientCodeList = this.params.PatientCodeList && this.params.PatientCodeList !== ''
          ? this.params.PatientCodeList
          : null;
        
        this.parameter.InsuranceCodeList =this.params.InsuranceCodeList && this.params.InsuranceCodeList !== ''
          ? this.params.InsuranceCodeList
          : null;
          
        this.parameter.InsTypeList =this.params.InsTypeList && this.params.InsTypeList !== ''
          ?this.params.InsTypeList
          : null;

        this.parameter.SearchCriteria = this.SearchCriteria;
      },

      initializePdfParameters() {
        this.reportParams = []
        this.reportParams.push({ paramName: 'PatientCode', paramValue: this.PatientCode})
        this.reportParams.push({ paramName: 'RecNo', paramValue: this.RecNo})
        this.reportParams.push({ paramName: 'ViewReports', paramValue: this.showModal})
        this.reportParams.push({ paramName: 'InsTypeList', paramValue: this.params.InsTypeList})
        this.reportParams.push({ paramName: 'InsuranceCodeList', paramValue: this.params.InsuranceCodeList})
        this.reportParams.push({ paramName: 'PatientCodeList', paramValue: this.params.PatientCodeList })
        this.reportParams.push({ paramName: 'rSearchCriteria', paramValue: this.SearchCriteria})
      },

      onClickShowReport() {
        this.isParamVisible = false
        this.initializePdfParameters()
        this.isReportVisible = true
        this.$refs.patientInsurances.buildDocument(this.reportParams)
      },
      
      ChangeDropDownPatients(values) {
        this.params.PatientCodeList = [];
        values.forEach(it => {
          this.params.PatientCodeList.push(it.patientcode)
        });
      },

      ChangeDropDownInsType(values) {
        this.params.InsTypeList = [];
        values.forEach(it => {
          this.params.InsTypeList.push(it.code)
        });
      },

      ChangeDropDownInsurances(values) {
        this.params.InsuranceCodeList = [];
        values.forEach(it => {
          this.params.InsuranceCodeList.push(it.insurancecode)
        });
      },

      getInsuranceCodeValues(value) {
        this.insCode = value.code;
        this.company = value.description;
      },

      customLabelPatients ({ patientName, patientcode }) {
        return `${patientName} – ${patientcode}`
      },

      getPatients() {              
        PatientService.getAll(this.parameter)
          .then((response) => {
          if(response.status == '200' && response.data && response.data.length > 0){
            this.PatientsList = response.data; 
            this.PatientsList.forEach(function(element) {
                element.patientName = element.firstname + " " + element.lastname;   
              });
            }      
          })
          .catch(error => {
            if (!error.response) {
                // network error
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
            } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
          });
      },

      getInsuranceTypesList() {
        InsuranceService.getPatientInsuranceTypes()
        .then((response) => {
          if (response.data) {
            this.InsuranceTypesList = response.data;
          }
        })
        .catch((error) => {
          if (error.response) {
            this.showMessage(this.$tc('Msg.Error'), error, "error");
          }
        });
      },

      getInsurances() {
        InsuranceService.getAllInsurance()
        .then((response) => {
          if (response.data) {
            this.Insurances = response.data;
          }
        })
        .catch((error) => {
          if (error.response) {
            this.showMessage(this.$tc('Msg.Error'), error, "error");
          }
        });
      },

      getSearchInsurances() {
        this.parameter.PageNumber = this.currentPage;
        this.parameter.PageSize = this.perPage;
        this.initializeParameters();

        InsuranceService.getAllInsuranceSearch(this.parameter, true)
          .then((response) => {
            if(response.status == '200' && response.data && response.data.length > 0){
              this.items = response.data;
              let headerString = response.headers["x-pagination"];
              this.Header = JSON.parse(headerString);
              this.totalRows = this.Header.TotalCount;
              this.items.forEach(item => {
                if (item.effectiveDate)	
                    item.effectiveDate = Utils.formatterDateToString(item.effectiveDate);
                if (item.patientDOB)	
                    item.patientDOB = Utils.formatterDateToString(item.patientDOB); 
                 if (item.termDate)	
                    item.termDate = Utils.formatterDateToString(item.termDate); 
              });
            }
            if(this.items.length === 0){
              this.ShowMessageIsEmpty = true;
            }
          })
          .catch(error => {
            this.showResponseErrorMessage(error);
          });
      },

      SearchInsurances(){
        this.items = [];
        this.currentPage = 1;
        this.parameter.PageNumber = 1;
        this.totalRows = this.items.length;
        this.getSearchInsurances();
      },
      
      pageChanged (page) {            
        this.currentPage = page;
        this.getSearchInsurances();    
      },

      PerPageFunction(perpage){
        this.perPage = perpage;  
        this.currentPage = 1;
        this.getSearchInsurances();
      },
      
      handleCSV(action) {
        this.initializeParameters();
        switch(action) {
          case 'export':
            this.$refs.csvExportHelper.exportCSV(this.parameter);
          break;
          case 'email':
            this.$refs.csvExportHelper.emailCSV(this.parameter);
          break;
          default:
            console.warn('unknow action:', action);
          break;
        }
      },

      handlePdf(action) {
        this.initializePdfParameters();
        switch(action) {
          case 'export':
            this.$refs.csvExportHelper.exportToPdf('PatientInsurances', true, false, this.reportParams);
          break;
          case 'email':
            this.$refs.csvExportHelper.emailPdf('PatientInsurances', true, false, this.reportParams);
          break;
          default:
            console.warn('unknow action:', action);
          break;
        }
      }
    },
    created() {
      if(this.showModal) {
        this.getPatients();
        this.getInsuranceTypesList()
        this.getInsurances()
      }
    },
    mounted () {
      if(!this.showModal)
        this.onClickShowReport();

      this.OptionsRightMenu.ItemsList = [];
      let layoutStatus = this.$store.state.layoutStatus;
      switch(layoutStatus) {
        case 'L0R1':
          this.OptionsRightMenu.favButtonAtion = false;
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        case 'L1R0':
        case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        default:
            this.OptionsRightMenu.favButtonAtion = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
      }

      EventBus.$on("ShowWeel", function (isShow) { 
        isShow ? this.$emit('load', true) : this.$emit('load', false);     
      }.bind(this));
    },

  })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
